export default {
  login: {
    succeed: "loginSucceed",
    failed: "loginFailed",
    usernameRequired: "usernameRequired",
    passwordRequired: "passwordRequired"
  },
  logout: {
    succeed: "logoutSucceed",
    failed: "logoutFailed"
  },
  request: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    processing: "requestProcessing"
  },
  session: {
    invalidToken: "invalidToken",
    expired: "sessionExpired",
    invalidSession: "invalidSession"
  },
  otp: {
    failed: "otpVerificationFailed",
    codeRequired: "codeRequired",
    invalidCode: "invalidCode",
    setupFailed: "otpSetupFailed",
    verificationFailed: "otpVerificationFailed"
  }
};
